import React, { useEffect } from "react";
import AlarmsOverviewCards from "./AlarmOverviewCards";
import AlarmDataGrid from "./AlarmOverviewDataGrid/AlarmDataGrid";

const AlarmOverview: React.FC<{
  alarmsGridId?: string;
  selectedSeverity?: string;
  onSelectedSeverityHandled?: () => void;
}> = ({ alarmsGridId = "alarm-overview-alarms", selectedSeverity, onSelectedSeverityHandled }) => {

  useEffect(() => {
    if (!selectedSeverity) return;

    let outerFrameId: number | undefined;
    let innerFrameId: number | undefined;

    // Ensure the section is laid out in the active tab before scrolling.
    outerFrameId = window.requestAnimationFrame(() => {
      innerFrameId = window.requestAnimationFrame(() => {
        const target = document.getElementById(alarmsGridId);
        if (target) {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }

        window.dispatchEvent(
          new CustomEvent("alarm-overview:filter", {
            detail: { severity: selectedSeverity },
          })
        );

        onSelectedSeverityHandled?.();
      });
    });

    return () => {
      if (outerFrameId !== undefined) {
        window.cancelAnimationFrame(outerFrameId);
      }
      if (innerFrameId !== undefined) {
        window.cancelAnimationFrame(innerFrameId);
      }
    };
  }, [alarmsGridId, onSelectedSeverityHandled, selectedSeverity]);

  return (
    <div
      className="p-4 md:px-8 md:py-6 space-y-8"
      style={{ backgroundColor: "var(--background)", minHeight: "100%" }}
    >
      <AlarmsOverviewCards alarmsGridId={alarmsGridId} />
      <AlarmDataGrid alarmsGridId={alarmsGridId} />
    </div>
  );
};

export default AlarmOverview;
